import { Container, Stack } from "@mui/material";
import { H1, Paragraph } from "./Typography";
import { SmartImage } from "./SmartImage";

export const TelegramError = () => {
  return (
    <Container maxWidth="sm" sx={{ height: "100%" }}>
      <Stack
        height="100%"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <SmartImage
          src="/images/icons/disconnected.png"
          alt="Telegram Required"
          height={100}
          width={100}
        />
        <H1>Telegram Required</H1>
        <Paragraph>
          This app can only be opened within Telegram. Please open it through
          Telegram instead.
        </Paragraph>
      </Stack>
    </Container>
  );
};
